// File: client_serena/src/components/HealthMetricsSection.js

import React, { useState } from "react";
import {
Box,
Button,
FormControl,
FormLabel,
Input,
Select,
Grid,
useToast,
Heading,
} from "@chakra-ui/react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function HealthMetricsSection({ metrics = {}, onSave }) {
const [age, setAge] = useState(metrics.age || "");
const [heightCm, setHeightCm] = useState(metrics.heightCm || "");
const [weightKg, setWeightKg] = useState(metrics.weightKg || "");
const [gender, setGender] = useState(metrics.gender || "");
const [activityLevel, setActivityLevel] = useState(metrics.activityLevel || "");
const [loading, setLoading] = useState(false);
const toast = useToast();

const handleSubmit = async (e) => {
e.preventDefault();
setLoading(true);
try {
const token = await window.firebase.auth().currentUser.getIdToken();

const res = await fetch(`${API_BASE_URL}/api/user/health-metrics`, {
method: "PATCH",
headers: {
"Content-Type": "application/json",
Authorization: `Bearer ${token}`,
},
body: JSON.stringify({
age: Number(age),
heightCm: Number(heightCm),
weightKg: Number(weightKg),
gender,
activityLevel,
}),
});

const data = await res.json();
if (!res.ok) throw new Error(data.error || "Update failed");

toast({
title: "✅ Health metrics updated",
description: "BMI and TDEE recalculated.",
status: "success",
isClosable: true,
});

if (onSave) onSave(data.updatedMetrics);
} catch (err) {
console.error(err);
toast({
title: "❌ Failed to update",
description: "Please try again.",
status: "error",
isClosable: true,
});
} finally {
setLoading(false);
}
};

return (
<Box as="form" onSubmit={handleSubmit} mt={4}>
<Heading size="md" mb={4}>Health Check Panel</Heading>

<Grid templateColumns={["1fr", "repeat(2, 1fr)"]} gap={4}>
<FormControl>
<FormLabel>Age</FormLabel>
<Input
type="number"
value={age}
onChange={(e) => setAge(e.target.value)}
placeholder="Enter age"
required
/>
</FormControl>

<FormControl>
<FormLabel>Height (cm)</FormLabel>
<Input
type="number"
value={heightCm}
onChange={(e) => setHeightCm(e.target.value)}
placeholder="e.g. 170"
required
/>
</FormControl>

<FormControl>
<FormLabel>Weight (kg)</FormLabel>
<Input
type="number"
value={weightKg}
onChange={(e) => setWeightKg(e.target.value)}
placeholder="e.g. 65"
required
/>
</FormControl>

<FormControl>
<FormLabel>Gender</FormLabel>
<Select
value={gender}
onChange={(e) => setGender(e.target.value)}
placeholder="Select gender"
required
>
<option value="male">Male</option>
<option value="female">Female</option>
<option value="other">Other</option>
</Select>
</FormControl>

<FormControl gridColumn="span 2">
<FormLabel>Activity Level</FormLabel>
<Select
value={activityLevel}
onChange={(e) => setActivityLevel(e.target.value)}
placeholder="Select your level"
required
>
<option value="sedentary">Sedentary</option>
<option value="light">Light</option>
<option value="moderate">Moderate</option>
<option value="active">Active</option>
<option value="very active">Very Active</option>
</Select>
</FormControl>
</Grid>

<Button
type="submit"
colorScheme="teal"
mt={6}
isLoading={loading}
loadingText="Saving"
>
Update Health Metrics
</Button>
</Box>
);
}

export default HealthMetricsSection;